if (!customElements.get('muticarousel-tabs')) {
  customElements.define(
    'muticarousel-tabs',
    class MulticarouselTabs extends HTMLElement {
      constructor() {
        super();
        this.tabsButtonsWrapper = this.querySelector('.tab-buttons');
      }

      connectedCallback() {
        const tabButtons = this.querySelectorAll('.carousel-tab .tab-button > button');

        if (!this.tabsButtonsWrapper || !tabButtons.length) return;
        this.querySelectorAll('.carousel-tab')[0].classList.add('active');
        this.cloneButtons(tabButtons);
        this.tabChange()
      }

      cloneButtons(tabButtons) {
        this.tabsButtonsWrapper.innerHTML = '';
        tabButtons.forEach((button, index) => {
        if(index === 0){
            button.classList.add('active')
        }
          const clone = button.cloneNode(true);
          clone.dataset.index = index;
          if (clone.id) {
            clone.id = `${clone.id}--clone`;
          }

          this.tabsButtonsWrapper.appendChild(clone);
        });
      }
      tabChange(){
        const tabButtons = this.tabsButtonsWrapper.querySelectorAll('.tab-buttons>button');
        tabButtons.forEach((button)=>{
          button.addEventListener('click', (e)=>{
            const tabId = e.target.dataset.tab;
            const seletctedTab = this.querySelector(`.carousel-tab[data-tab='${tabId}']`)

            this.querySelectorAll('.tab-buttons>button.active').forEach((activebtn)=>{
              activebtn.classList.remove('active');
            })
            e.target.classList.toggle('active');

            this.querySelectorAll('.carousel-tab.active').forEach((tab)=>{
              tab.classList.remove('active');
            })
            seletctedTab.classList.add('active')
          })
          
        })
      }
    }
  );
}
